// Native port of the legacy template shell public/js/global/site.min.js.
// Behavior is preserved 1:1 with the jQuery original for every reachable
// code path, with one deliberate change: the dropdown data-animation hook is
// fixed for Bootstrap 5's event shape (see dropdownAnimation). The original
// also carried template features whose markup exists nowhere in this
// application (a navbar search, a responsive mega menu, and
// .dropdown-menu-media containers) — verified unreachable and removed rather
// than ported: no selector under src/, index.html, agent-login.html, or the
// e2e fixtures can ever match them.

interface WavesGlobal {
  init: () => void;
  attach: (selector: string, classes: string[]) => void;
}

declare global {
  interface Window {
    Site: { run: (next?: unknown) => void };
    Waves?: WavesGlobal;
  }
}

function stopPropagationInside(selector: string) {
  return (event: Event) => {
    const target = event.target;
    if (target instanceof Element && target.closest(selector)) {
      event.stopPropagation();
    }
  };
}

function dropdownAnimation(event: Event) {
  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }
  const relatedTarget = (event as Event & { relatedTarget?: unknown }).relatedTarget;
  const trigger =
    relatedTarget instanceof Element ? relatedTarget : target.querySelector(':scope > [data-bs-toggle="dropdown"]');
  const animation = trigger instanceof HTMLElement ? trigger.dataset.animation : undefined;
  if (!animation) {
    return;
  }
  // Bootstrap 5 fires show.bs.dropdown at the toggle, so the menu is resolved
  // from the toggle's parent. The jQuery original looked for a child of the
  // event target — a silent no-op ever since the Bootstrap 5 migration — and
  // this deliberately restores the animation to its pre-migration behavior.
  const scope = trigger instanceof Element ? trigger.parentElement : target;
  if (!scope) {
    return;
  }
  for (const menu of scope.querySelectorAll(":scope > .dropdown-menu")) {
    menu.classList.add(`animation-${animation}`);
    menu.addEventListener(
      "animationend",
      () => {
        menu.classList.remove(`animation-${animation}`);
      },
      { once: true },
    );
  }
}

export function initLegacySiteShell(): void {
  window.Site = {
    run: () => {
      document.addEventListener("click", stopPropagationInside(".navbar-mega .dropdown-menu"));
      document.addEventListener("show.bs.dropdown", dropdownAnimation);
    },
  };

  if (typeof window.Waves !== "undefined") {
    window.Waves.init();
    window.Waves.attach(".site-menu-item > a", ["waves-classic"]);
    window.Waves.attach(".site-navbar .navbar-toolbar [data-bs-toggle='menubar']", ["waves-light", "waves-round"]);
    window.Waves.attach(".page-header-actions .btn:not(.btn-inverse)", ["waves-light", "waves-round"]);
    window.Waves.attach(".page-header-actions .btn-inverse", ["waves-classic", "waves-round"]);
    window.Waves.attach(
      ".page > div:not(.page-header) .btn:not(.ladda-button):not(.btn-round):not(.btn-pure):not(.btn-floating):not(.btn-flat)",
      ["waves-light"],
    );
    window.Waves.attach(
      ".page > div:not(.page-header) .btn-pure:not(.ladda-button):not(.btn-round):not(.btn-floating):not(.btn-flat):not(.icon)",
      ["waves-classic"],
    );
  }

  window.Site.run();
}
